import React from "react";
//home page can be changed for any page
import CenterPanelCustomerRecentAppointment from "./centerPanel";
import BottomPanelCustomerRecentAppointment from "./bottomPanel";

export default function CustomerRecentAppointmentContent() {
  return (
    <div>
      <CenterPanelCustomerRecentAppointment />
      <BottomPanelCustomerRecentAppointment />
    </div>
  );
}
